import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import * as serviceWorker from './serviceWorker';
import {constant} from "./common/constant";
import {UAlertProvider} from 'ubs-framework/v2/UAlert';
import * as Sentry from "@sentry/react";

const environment = window.location.href.includes('.superworks.net') ? 'staging' : window.location.href.includes('.superworks.app') ? 'beta' : window.location.href.includes('.superworks.com') ? 'production' : 'local';

Sentry.init({
  dsn: "https://e34a28897f5f3ce933dffebfd41b5bf2@o4510471619149824.ingest.us.sentry.io/4510622356275200",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    // send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
  environment: environment
});

document.addEventListener('keypress', logKey);

let logger = function () {
    /* +-------------------------------------------------------------------+
     desc: Enable or disable logger and disable warn function.
     +-------------------------------------------------------------------+ */
    let oldConsoleLog = null;
    let pub = {};

    pub.enableLogger = function enableLogger() {
        if (oldConsoleLog == null) return;
        window['console']['log'] = oldConsoleLog;
        console.log('=== LOG ENABLED ===');
    };
    pub.disableLogger = function disableLogger() {
        oldConsoleLog = console.log;
        window['console']['log'] = () => {
        };
    };
    pub.disableWarn = function disableWarn() {
        window['console']['warn'] = () => {
        };
    };
    return pub;
}();

function logKey(e) {
    /* +-------------------------------------------------------------------+
     desc: define log enable disable key.
     +-------------------------------------------------------------------+ */
    if (e.ctrlKey && e.shiftKey) {
        switch (e.code) {
            case 'KeyS':
                logger.disableLogger();
                break;
            case 'KeyE':
                logger.enableLogger();
                break;
            default:
                break;
        }
    }
}

if (window.location.hostname === 'account.superworks.com') {
    logger.disableLogger();
    logger.disableWarn();
} else {
    logger.disableWarn();
}

if (constant.PLATFORM === 'electron') {
    let renderer = document.createElement('script');
    renderer.setAttribute('src', "/electron/renderer.js");
    renderer.setAttribute('async', true);
    document.body.appendChild(renderer);
}

ReactDOM.render(<React.StrictMode>
    <Provider store={ store }>
    <UAlertProvider>
            <App/>
        </UAlertProvider>

    </Provider>
</React.StrictMode>,
  document.getElementById('root'),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
